import { Component } from '@angular/core';

@Component({
    selector: 'app-koffer',
    templateUrl: './koffer.component.html',
    styleUrls: ['./koffer.component.scss'],
    standalone: false
})
export class KofferComponent {
  constructor() {}
}
